'use client';

import { useEffect } from 'react';
import Cookies from 'js-cookie';
import { useRouter, useSearchParams } from 'next/navigation';
import { DynamicTokenAuthHandler } from '@/entities/session/ui/dynamic-token-auth-handler';

interface StartQueryInitializerProps {
  onCashbackOpen: () => void;
}

export const StartQueryInitializer = ({
  onCashbackOpen,
}: StartQueryInitializerProps) => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const tokenParams = searchParams.get('token');
  const tgWebAppStartParam = searchParams.get('tgWebAppStartParam');
  const modalSearchParam = searchParams.get('modal');

  useEffect(() => {
    if (modalSearchParam === 'cashback') {
      onCashbackOpen();
    }

    if (!tgWebAppStartParam) return;

    const startParams = tgWebAppStartParam.split('_');
    const token = startParams[0];
    const page = startParams[1];

    if (token) {
      Cookies.set('sessionId', token, { expires: 7 });
    }

    switch (page) {
      case 'deposit':
        router.push('/?deposit=1');
        break;
      case 'withdraw':
        router.push('/?withdraw=1');
        break;
      case 'profile':
        router.push('/profile');
        break;
      case 'bonuses':
        router.push('/bonuses');
        break;
      default:
        router.push('/');
        break;
    }
  }, [
    modalSearchParam,
    onCashbackOpen,
    router,
    tgWebAppStartParam,
  ]);

  return tokenParams ? <DynamicTokenAuthHandler token={tokenParams} /> : null;
};
